import { render } from "./BlogCategory.vue?vue&type=template&id=183f3c6a"
import script from "./BlogCategory.vue?vue&type=script&lang=js"
export * from "./BlogCategory.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__